import { Helmet } from "react-helmet-async";

const SEO = ({ title, description, keywords }) => {
    return (
        <Helmet>
            <title>{title}</title>

            <meta name="description" content={description} key="desc" />
            <meta name="keywords" content={keywords} />

            <meta name="robots" content="index, follow" />

            {/* 🔥 ADD THIS */}
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:type" content="website" />
            <meta property="og:image" content="https://probillrcm.com/og-image.jpg" />
        </Helmet>
    );
};

export default SEO;
